<template>
  <div>
    <component :is="currentComponent" ref="activeDashboardComponent"></component>

    <router-view></router-view>
  </div>
</template>

<script>
import PageOptions from "@/Options/PageOptions.js";

/*
Import all parent components to this file.
*/

//Welcome
import Welcome from "./Welcome/Welcome";

//Highlight
import Highlight from "./Dashboard/Highlight/highlight";
// import NewHighlight from './Dashboard/HighlightTemp/newFormatHighlight'

//Edit Profile
import EditProfile from "./Auth/EditProfile";

//H1
//qr-registration
import DailyQrRegistration from "./Dashboard/H1/QrRegistration/Daily/DailyQrRegistration";
import MonthlyQrRegistration from "./Dashboard/H1/QrRegistration/Monthly/MonthlyQrRegistration";
import MonitoringQr from "./Dashboard/H1/QrRegistration/MonitoringQr/MonitoringQr";
//stock-details
import StockAvailability from "./Dashboard/H1/StockDetails/StockAvailability/StockAvailability";
import StockInTransit from "./Dashboard/H1/StockDetails/StockInTransit/StockInTransit";
import AverageDaysOfStock from "./Dashboard/H1/StockDetails/AverageDaysOfStock/AverageDaysOfStock";
import AgingStock from "./Dashboard/H1/StockDetails/AgingStock/AgingStock";
//sales
import RegionalSales from "./Dashboard/H1/Sales/RegionalSales/RegionalSales";
import RetailSales from "./Dashboard/H1/Sales/RetailSales/RetailSales";
//others
import WarehouseBehavior from "./Dashboard/H1/WarehouseBehavior/WarehouseBehavior";
import WarehouseBehaviorOutgoing from "./Dashboard/H1/WarehouseBehavior/Outgoing";
import LeadTimeDelivery from "./Dashboard/H1/LeadTimeDelivery/LeadTimeDelivery";
import CustomerLocation from "./Dashboard/H1/CustomerLocation/CustomerLocation";
import VehicleDeviation from "./Dashboard/H1/VehicleDeviation/VehicleDeviation";
import ExpeditionMonitoring from "./Dashboard/H1/ExpeditionMonitoring/ExpeditionMonitoring";
import LogisticPartner from "./Dashboard/H1/LogisticPartner/LogisticPartner";
import TrendSales from "./Dashboard/H1/TrendSales/TrendSales.vue";
import MCDReport from "./Dashboard/H1/MCDReport/Main.vue";
import VirtualStockExpedition from "./Dashboard/H1/VirtualStockExpedition/VirtualStockExpedition.vue";
import SalesTerritory from "./Dashboard/H1/SalesTerritory/SalesTerritory.vue";

//H2
import QrRegistration from "./Dashboard/H2/QrRegistration/qrRegistration";
import ReplacedQr from "./Dashboard/H2/ReplacedQr/replacedQr";
import ChangeOwnership from "./Dashboard/H2/ChangeOwnership/changeOwnership";
import ServiceCycle from "./Dashboard/H2/ServiceCycle/serviceCycle";
import WorkshopTraffic from "./Dashboard/H2/WorkshopTraffic/workshopTraffic";
import ServiceRecord from "./Dashboard/H2/ServiceRecord/ServiceRecord.vue";

//Report
import H1Report from "./Dashboard/Report/H1Report/h1Report";
import H2Report from "./Dashboard/Report/H2Report/h2Report";
import SummaryQrRegistration from "./Dashboard/Report/SummaryQRRegistration/summaryQrRegistration";
import SummaryLog from "./Dashboard/Report/SummaryLog/summaryLog";
import VehicleSearch from "./Dashboard/Report/VehicleSearch/vehicleSearch";
import ReportQRCode from "./Dashboard/Report/QRCode/qrCode";
import ReportQRCodeReplacement from "./Dashboard/Report/QRCodeReplacement/qrCodeReplacement";
import ReportChangeOwnership from "./Dashboard/Report/ChangeOwnership/changeOwnership";
import Customer from "./Dashboard/Report/Customer/customer";
import LogReport from "./Dashboard/Report/LogReport/logReport";
import SummaryApiLog from "./Dashboard/Report/SummaryApiLog/SummaryApiLog";
import SummaryDocumentData from "./Dashboard/Report/SummaryDocumentData/SummaryDocumentData";
import ReportDealerDelivery from "./Dashboard/Report/DealerDelivery/DealerDelivery";
import ReportInventory from "./Dashboard/Report/ReportInventory/ReportInventory.vue";
import StatusTO from "./Dashboard/Report/StatusTO/StatusTO.vue";
import SuggestRing from "./Dashboard/Report/SuggestRing/SuggestRing";
import ReportCRM from "./Dashboard/Report/ReportCRM/ReportCRM.vue";
import ReportTrackingUnit from "./Dashboard/Report/ReportTrackingUnit/ReportTrackingUnit.vue";
import ReportSSU from "./Dashboard/Report/ReportSSU/ReportSSU.vue";
import DownloadReport from "./Dashboard/Report/DownloadReport/downloadReport.vue";

//QR Codes
import DistributionMonitoring from "./Dashboard/QRCode/DistributionMonitoring/DistributionMonitoring.vue";
import QRIssue from "./Dashboard/QRCode/QRIssue/QRIssue.vue";
import QRIssueDetail from "./Dashboard/QRCode/QRIssue/QRIssueDetail.vue";
import QRReceipt from "./Dashboard/QRCode/QRReceipt/QRReceipt.vue";
import QRDealerUsed from "./Dashboard/QRCode/QRDealerUsed/QRDealerUsed.vue";
import QRDealerStock from "./Dashboard/QRCode/QRDealerStock/QRDealerStock.vue";
import QRStock from "./Dashboard/QRCode/QRStock/QRStock.vue";
import QRStockSend from "./Dashboard/QRCode/QRStock/QRStockSend.vue";
import QRStockEdit from "./Dashboard/QRCode/QRStock/QRStockEdit.vue";
import QRHistory from "./Dashboard/QRCode/QRHistory/QRHistory.vue";
import TransferAmountSetting from "./Dashboard/QRCode/TransferAmountSetting/TransferAmountSetting.vue";
import ReturnTransferAccess from "./Dashboard/QRCode/ReturnTransferAccess/ReturnTransferAccess.vue";
// import RepeatedMapping from "./Dashboard/QRCode/RepeatedMapping/RepeatedMapping.vue";

//Setting
import UserManagement from "./Dashboard/Setting/UserManagement/userManagement";
import Target from "./Dashboard/Setting/Target/target";
import DealerRadius from "./Dashboard/Setting/DealerRadius/DealerRadius";
import Calendar from "./Dashboard/Setting/Calendar/calendar";
import MCDTarget from "./Dashboard/Setting/MCDTarget/MCDTarget";
import ServiceLostSettings from "./Dashboard/Setting/ServiceLostSettings/ServiceLostSettings.vue";
import VehicleType from "./Dashboard/Setting/VehicleType/VehicleType.vue";
import LocationSettings from "./Dashboard/Setting/Locations/Locations.vue";
import LoginHistory from "./Dashboard/Setting/LoginHistory/loginHistory.vue";

//UserDealer
import TeritoryUserDealer from "./Dashboard/UserDealer/territoryUserDealer";

// Library
import moment from "moment";
// import QRDealerStockHistory from './Dashboard/QRCode/QRDealerStock/children/QRDealerStockHistory.vue';
export default {
  metaInfo: {
    title: "BI Dashboard",
    titleTemplate: "%s - QTrust",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  components: {
    //Welcome
    Welcome,

    //highlight
    Highlight,
    // NewHighlight,

    //Edit Profile
    EditProfile,

    //h1
    DailyQrRegistration,
    MonthlyQrRegistration,
    MonitoringQr,
    StockAvailability,
    StockInTransit,
    AverageDaysOfStock,
    AgingStock,
    RegionalSales,
    RetailSales,
    WarehouseBehavior,
    WarehouseBehaviorOutgoing,
    LeadTimeDelivery,
    CustomerLocation,
    VehicleDeviation,
    ExpeditionMonitoring,
    LogisticPartner,
    TrendSales,
    MCDReport,
    VirtualStockExpedition,
    SalesTerritory,

    //h2
    QrRegistration,
    ReplacedQr,
    ChangeOwnership,
    ServiceCycle,
    WorkshopTraffic,
    ServiceRecord,

    //report
    H1Report,
    H2Report,
    SummaryQrRegistration,
    SummaryLog,
    VehicleSearch,
    ReportQRCode,
    ReportQRCodeReplacement,
    ReportChangeOwnership,
    Customer,
    LogReport,
    SummaryApiLog,
    SummaryDocumentData,
    ReportDealerDelivery,
    ReportInventory,
    StatusTO,
    SuggestRing,
    ReportCRM,
    ReportTrackingUnit,
    ReportSSU,
    DownloadReport,

    //qr codes
    DistributionMonitoring,
    QRIssue,
    QRIssueDetail,
    QRStockIssueDetail: QRIssueDetail,
    QRHistoryIssueDetail: QRIssueDetail,
    QRReceipt,
    QRDealerUsed,
    QRDealerStock,
    QRStock,
    QRStockSend,
    QRStockEdit,
    QRHistory,
    TransferAmountSetting,
    ReturnTransferAccess,
    // RepeatedMapping,
    // QRDealerStockHistory,

    //user Dealer
    TeritoryUserDealer,

    //setting
    UserManagement,
    Target,
    DealerRadius,
    Calendar,
    MCDTarget,
    ServiceLostSettings,
    VehicleType,
    LocationSettings,
    LoginHistory,
  },
  data() {
    return {
      pageOptions: PageOptions,
      currentComponent: "",
    };
  },
  created() {
    this.pageOptions.pageEmpty = false;
  },
  mounted() {
    this.currentComponent = this.$route.name;
    let user = this.$store.state.userData.userData;

    console.log(this.$apm);

    this.$apm.setUserContext({
      id: user.user_id,
      username: user.username,
    });

    this.$apm.setCustomContext({
      access_time: new moment().format("Y-MM-DD HH:mm:ss"),
      route: this.$route.path,
    });
  },
  beforeRouteUpdate(to, from, next) {
    const child = this.$refs.activeDashboardComponent;
    if (child && typeof child.canLeaveRoute === "function") {
      const allowed = child.canLeaveRoute(to, () => {
        this.currentComponent = to.name;
        next();
      });
      if (!allowed) {
        return;
      }
    }
    this.currentComponent = to.name;
    next();
  },
  beforeRouteLeave(to, from, next) {
    const child = this.$refs.activeDashboardComponent;
    if (child && typeof child.canLeaveRoute === "function") {
      const allowed = child.canLeaveRoute(to, () => {
        PageOptions.pageEmpty = true;
        next();
      });
      if (!allowed) {
        return;
      }
    }
    PageOptions.pageEmpty = true;
    next();
  },
  methods: {},
};
</script>

<style>
.outerBox {
  padding: 0 20px;
}
.innerBox {
  padding: 1.5rem;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  background-color: white;
  box-shadow: 2px 2px 5px #e0e0e0;
}
</style>
